import React, { useEffect, useRef, useState } from 'react'
import { PREFERRED_LANGUAGES } from '../../constants/preferredLanguages'

const MAX = 3

export default function LanguageMultiSelect({ value = [], onChange, max = MAX }) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)

  useEffect(() => {
    const onDoc = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) setOpen(false)
    }
    document.addEventListener('mousedown', onDoc)
    return () => document.removeEventListener('mousedown', onDoc)
  }, [])

  const toggle = (code) => {
    if (value.includes(code)) {
      onChange(value.filter((c) => c !== code))
      return
    }
    if (value.length >= max) return
    onChange([...value, code])
  }

  const selectedLabels = value
    .map((code) => PREFERRED_LANGUAGES.find((l) => l.code === code)?.label)
    .filter(Boolean)

  return (
    <div className="auth-lang-select" ref={rootRef}>
      <button
        type="button"
        className="auth-lang-select-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <span className={selectedLabels.length ? '' : 'auth-lang-placeholder'}>
          {selectedLabels.length ? selectedLabels.join(', ') : 'Select up to 3 languages'}
        </span>
        <span className="auth-lang-chevron">{open ? '▴' : '▾'}</span>
      </button>
      {open && (
        <div className="auth-lang-dropdown" role="listbox">
          <div className="auth-lang-dropdown-hint">Select up to {max} languages</div>
          {PREFERRED_LANGUAGES.map((lang) => {
            const checked = value.includes(lang.code)
            const disabled = !checked && value.length >= max
            return (
              <button
                key={lang.code}
                type="button"
                role="option"
                aria-selected={checked}
                className={`auth-lang-option${checked ? ' selected' : ''}${disabled ? ' disabled' : ''}`}
                onClick={() => !disabled && toggle(lang.code)}
              >
                <span className="auth-lang-check">{checked ? '✓' : ''}</span>
                {lang.label}
              </button>
            )
          })}
        </div>
      )}
    </div>
  )
}
